document.addEventListener('DOMContentLoaded', () => {

    // ── CONFIG ──
    const FRAME_COUNT = 298;
    const FRAME_EXT   = 'jpg';

    // Frame base URL — set by the inline script in hero section via window global
    const HERO_FRAME_BASE = window.__HERO_FRAME_BASE || 'frames';

    // ── ELEMENTS ──
    const loader      = document.getElementById('loader');
    const navbar      = document.getElementById('navbar');
    const heroSection = document.getElementById('hero-scroll');
    const heroCanvas  = document.getElementById('hero-canvas');
    const heroCtx     = heroCanvas ? heroCanvas.getContext('2d') : null;

    // Cached canvas dimensions — updated on resize only
    const canvasDims = { hero: { w: 0, h: 0 } };

    // ── FRAME PRELOADER ──
    const images = [];
    let loadedCount = 0;
    let failedCount = 0;
    let heroCurrentFrame = -1;

    function preloadFrames() {
        for (let i = 1; i <= FRAME_COUNT; i++) {
            const img = new Image();
            const num = String(i).padStart(4, '0');
            img.src = `${HERO_FRAME_BASE}/frame_${num}.${FRAME_EXT}`;
            img.onload = () => {
                loadedCount++;
                if (loadedCount + failedCount === FRAME_COUNT) onFramesReady();
            };
            img.onerror = () => {
                failedCount++;
                if (loadedCount + failedCount === FRAME_COUNT) onFramesReady();
            };
            images.push(img);
        }
        setTimeout(() => {
            if (loader && !loader.classList.contains('loaded')) loader.classList.add('loaded');
        }, 2000);
    }

    function sizeCanvas(canvas, key) {
        const dpr = window.devicePixelRatio || 1;
        const rect = canvas.getBoundingClientRect();
        canvas.width  = rect.width * dpr;
        canvas.height = rect.height * dpr;
        canvas.getContext('2d').setTransform(dpr, 0, 0, dpr, 0, 0);
        if (key) canvasDims[key] = { w: rect.width, h: rect.height };
    }

    function drawContain(ctx, cw, ch, img) {
        const iw = img.naturalWidth;
        const ih = img.naturalHeight;
        const scale = Math.min(cw / iw, ch / ih);
        const dw = iw * scale;
        const dh = ih * scale;
        // Offset steak further right to give space to centred text
        const dx = cw * 0.82 - dw * 0.35;
        const dy = (ch - dh) / 2;
        ctx.clearRect(0, 0, cw, ch);
        ctx.drawImage(img, dx, dy, dw, dh);
    }

    function onFramesReady() {
        const firstValid = images.find(img => img.naturalWidth > 0);
        if (firstValid && heroCanvas) {
            sizeCanvas(heroCanvas, 'hero');
            drawHeroFrame(0);
        }
        if (loader) loader.classList.add('loaded');
    }

    function drawHeroFrame(index) {
        if (index === heroCurrentFrame) return;
        if (!images[index] || images[index].naturalWidth === 0) return;
        heroCurrentFrame = index;
        drawContain(heroCtx, canvasDims.hero.w, canvasDims.hero.h, images[index]);
    }

    window.addEventListener('resize', () => {
        if (heroCanvas) { sizeCanvas(heroCanvas, 'hero'); heroCurrentFrame = -1; }
        onScroll();
    });

    // ── SCROLL HANDLER ──
    function onScroll() {
        const scrollY = window.scrollY;

        // Navbar background on scroll
        if (navbar) navbar.classList.toggle('nav-scrolled', scrollY > 80);

        // ── Hero scroll-driven animation (reversible) ──
        if (heroSection && heroCanvas) {
            const heroTop    = heroSection.offsetTop;
            const heroHeight = heroSection.scrollHeight - window.innerHeight;
            const heroOffset = scrollY - heroTop;
            const heroFrac   = heroHeight <= 0 ? 0 : Math.min(1, Math.max(0, heroOffset / heroHeight));

            const heroFrameIdx = Math.min(FRAME_COUNT - 1, Math.floor(heroFrac * FRAME_COUNT));
            drawHeroFrame(heroFrameIdx);
        }
    }

    // ── INIT ──
    if (heroCanvas) {
        preloadFrames();
    } else if (loader) {
        loader.classList.add('loaded');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // ── SCROLL PROGRESS BAR ──
    const progressBar = document.getElementById('scroll-progress');
    function updateProgress() {
        const scrollTop = window.scrollY;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const progress = (scrollTop / docHeight) * 100;
        if (progressBar) progressBar.style.width = progress + '%';
    }
    window.addEventListener('scroll', updateProgress, { passive: true });

    // ── SCROLL REVEAL ──
    const revealEls = document.querySelectorAll('.reveal');
    const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                revealObserver.unobserve(entry.target);
            }
        });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });
    revealEls.forEach(el => revealObserver.observe(el));
});
